export enum AdjustedTargetMarginLevelType {
    Facility = 'facility',
    System = 'system',
    Vms = 'vms',
    Job = 'job'
}

export type AdjustedTargetMarginLevel =
    | AdjustedTargetMarginLevelType.Job
    | AdjustedTargetMarginLevelType.Facility
    | AdjustedTargetMarginLevelType.System
    | AdjustedTargetMarginLevelType.Vms;
